import InfoBar from '../redesign/components/InfoBar'
import classes from './nivelacijaKvota.module.css'
import classesK from '../kalkulatori.module.css'
import { useState, useEffect } from 'react'
import { betkoPopupWithAction } from '../../utils/BetkoPopupModal'
import OddsCalculator from '../redesign/components/OddsCalculator'
import ResultsSection from '../redesign/components/ResultsSection'
import runCalculator from '../api/runCalculator'

const category = 'odds'
const slug = 'odds-leveling'

// Format an API number (e.g. 1.94, -0.75) into the same 2-decimal string the
// local logic produced; null (API's "-") maps back to '-'.
const fmtCell = (value) =>
  value === null || value === undefined || isNaN(Number(value))
    ? '-'
    : Number(value).toFixed(2)

// Implied probability % -> the "54.05%" chance string the JSX renders directly.
const fmtChance = (value) =>
  value === null || value === undefined || isNaN(Number(value))
    ? '0%'
    : Number(value).toFixed(2) + '%'

const NivelacijaKvota = () => {
  const [data, setData] = useState({
    values: {
      secondGames: ['', '', '', ''],
      thirdGames: ['', '', '', '', '', ''],
      fourthGames: ['', '', '', '', '', '', '', ''],
      fifthGames: ['', '', '', '', '', '', '', '', '', ''],
    },

    results: {
      secondGames: {
        names: ['-', '-'],
        chances: ['', ''],
        realOdds: ['', ''],
        realOddsPercentage: ['', ''],
        profit: [0],
      },
      thirdGames: {
        names: ['', '', ''],
        chances: ['', '', ''],
        realOdds: ['', '', ''],
        realOddsPercentage: ['', '', ''],
        profit: [0],
      },
      fourthGames: {
        names: ['', '', '', ''],
        chances: ['', '', '', ''],
        realOdds: ['', '', '', ''],
        realOddsPercentage: ['', '', '', ''],
        profit: [0],
      },
      fifthGames: {
        names: ['', '', '', '', ''],
        chances: ['', '', '', '', ''],
        realOdds: ['', '', '', '', ''],
        realOddsPercentage: ['', '', '', '', ''],
        profit: [0],
      },
    },
  })

  const [error, setError] = useState(false)
  const [apiError, setApiError] = useState('')
  const [loading, setLoading] = useState(false)
  const [disabled, setDisabled] = useState(true)

  const clearFields = () => {
    setData({
      values: {
        secondGames: ['', '', '', ''],
        thirdGames: ['', '', '', '', '', ''],
        fourthGames: ['', '', '', '', '', '', '', ''],
        fifthGames: ['', '', '', '', '', '', '', '', '', ''],
      },

      results: {
        secondGames: {
          names: ['', ''],
          chances: ['', ''],
          realOdds: ['', ''],
          realOddsPercentage: ['', ''],
          profit: [0],
        },
        thirdGames: {
          names: ['', '', ''],
          chances: ['', '', ''],
          realOdds: ['', '', ''],
          realOddsPercentage: ['', '', ''],
          profit: [0],
        },
        fourthGames: {
          names: ['', '', '', ''],
          chances: ['', '', '', ''],
          realOdds: ['', '', '', ''],
          realOddsPercentage: ['', '', '', ''],
          profit: [0],
        },
        fifthGames: {
          names: ['', '', '', '', ''],
          chances: ['', '', '', '', ''],
          realOdds: ['', '', '', '', ''],
          realOddsPercentage: ['', '', '', '', ''],
          profit: [0],
        },
      },
    })
    setShowInputArea(true)
    setToggleSecondResults(false)
    setToggleThirdResults(false)
    setToggleFourthResults(false)
    setToggleFifthResults(false)
  }
  // Build the 14-element oddsList the endpoint expects:
  //   [0-1] secondGames, [2-4] thirdGames, [5-8] fourthGames, [9-13] fifthGames.
  // Each section's odds live after its name fields (slice by row count). Empty /
  // invalid slots are sent as a neutral valid odd so the API's schema validates;
  // unfilled sections are never displayed (their "Prikaži rezultate" button is
  // hidden until that section is complete), so only filled sections' real odds
  // ever drive the rendered numbers.
  const buildBody = () => {
    const sectionOdds = (key, start) =>
      data.values[key].slice(start).map((odd) => {
        const n = parseFloat(odd)
        return isNaN(n) || n <= 1 ? 2 : n
      })

    return {
      oddsList: [
        ...sectionOdds('secondGames', 2),
        ...sectionOdds('thirdGames', 3),
        ...sectionOdds('fourthGames', 4),
        ...sectionOdds('fifthGames', 5),
      ],
    }
  }

  const calculateWinningChances = async () => {
    setLoading(true)
    setApiError('')

    try {
      const output = await runCalculator(category, slug, buildBody())

      const probs = output.impliedProbabilitiesPct || []
      const margin = output.bookmakerMargin || []
      const two = output.twoOutcomes || {}
      const three = output.threeOutcomes || {}
      const four = output.fourOutcomes || {}
      const five = output.fiveOutcomes || {}

      setData((prevData) => ({
        ...prevData,
        results: {
          secondGames: {
            ...prevData.results.secondGames,
            names: [
              prevData.values.secondGames[0],
              prevData.values.secondGames[1],
            ],
            chances: [fmtChance(probs[0]), fmtChance(probs[1])],
            realOdds: [fmtCell(two.AJ118), fmtCell(two.AK118)],
            realOddsPercentage: [fmtCell(two.AH118), fmtCell(two.AI118)],
            profit: [fmtCell(margin[0])],
          },
          thirdGames: {
            ...prevData.results.thirdGames,
            names: [
              prevData.values.thirdGames[0],
              prevData.values.thirdGames[1],
              prevData.values.thirdGames[2],
            ],
            chances: [
              fmtChance(probs[2]),
              fmtChance(probs[3]),
              fmtChance(probs[4]),
            ],
            realOdds: [
              fmtCell(three.AL115),
              fmtCell(three.AM115),
              fmtCell(three.AN115),
            ],
            realOddsPercentage: [
              fmtCell(three.AH115),
              fmtCell(three.AI115),
              fmtCell(three.AJ115),
            ],
            profit: [fmtCell(margin[1])],
          },
          fourthGames: {
            ...prevData.results.fourthGames,
            names: [
              prevData.values.fourthGames[0],
              prevData.values.fourthGames[1],
              prevData.values.fourthGames[2],
              prevData.values.fourthGames[3],
            ],
            chances: [
              fmtChance(probs[5]),
              fmtChance(probs[6]),
              fmtChance(probs[7]),
              fmtChance(probs[8]),
            ],
            realOdds: [
              fmtCell(four.W122),
              fmtCell(four.Y122),
              fmtCell(four.AA122),
              fmtCell(four.AC122),
            ],
            realOddsPercentage: [
              fmtCell(four.W121),
              fmtCell(four.Y121),
              fmtCell(four.AA121),
              fmtCell(four.AC121),
            ],
            profit: [fmtCell(margin[2])],
          },
          fifthGames: {
            ...prevData.results.fifthGames,
            names: [
              prevData.values.fifthGames[0],
              prevData.values.fifthGames[1],
              prevData.values.fifthGames[2],
              prevData.values.fifthGames[3],
              prevData.values.fifthGames[4],
            ],
            chances: [
              fmtChance(probs[9]),
              fmtChance(probs[10]),
              fmtChance(probs[11]),
              fmtChance(probs[12]),
              fmtChance(probs[13]),
            ],
            realOdds: [
              fmtCell(five.U134),
              fmtCell(five.V134),
              fmtCell(five.W134),
              fmtCell(five.Y134),
              fmtCell(five.AA134),
            ],
            realOddsPercentage: [
              fmtCell(five.U132),
              fmtCell(five.V132),
              fmtCell(five.W132),
              fmtCell(five.Y132),
              fmtCell(five.AA132),
            ],
            profit: [fmtCell(margin[3])],
          },
        },
      }))
    } catch (err) {
      setApiError('Greška pri obračunu, pokušajte ponovo.')
    } finally {
      setLoading(false)
    }
  }

  const [showInputArea, setShowInputArea] = useState(true)
  const toggleInputArea = () => {
    if (!showInputArea) {
      clearFields()
      return
    }
    setShowInputArea((prev) => !prev)
  }
  const updateDisabledState = () => {
    const updatedDisabledState = {
      secondGames: data.values.secondGames.every((field) => field !== ''),
      thirdGames: data.values.thirdGames.every((field) => field !== ''),
      fourthGames: data.values.fourthGames.every((field) => field !== ''),
      fifthGames: data.values.fifthGames.every((field) => field !== ''),
    }
    setDisabled((prevDisabled) => ({
      ...prevDisabled,
      ...updatedDisabledState,
    }))
  }

  useEffect(() => {
    updateDisabledState()
  }, [data.values])
  console.log('disabled', disabled)

  useEffect(() => {
    if (error) {
      betkoPopupWithAction(
        'Greška',
        'Molimo proverite da li su svi podaci ispravno uneti i ponovo pokušajte.'
      )
    }
  }, [error])

  console.log('data', data)

  const [toggleSecondResults, setToggleSecondResults] = useState(false)
  const [toggleThirdResults, setToggleThirdResults] = useState(false)
  const [toggleFourthResults, setToggleFourthResults] = useState(false)
  const [toggleFifthResults, setToggleFifthResults] = useState(false)

  // Explicit results action: fetch from the metered API once, then reveal the
  // requested section's results.
  const showResults = async (toggle) => {
    await calculateWinningChances()
    toggle(true)
  }

  return (
    <div className={classesK.container}>
      <InfoBar calculatorType={`Nivelacija kvota`} onRefresh={clearFields} />
      <div className={classesK.contentContainer}>
        {apiError && (
          <div style={{ color: 'red', textAlign: 'center', marginTop: '8px' }}>
            {apiError}
          </div>
        )}
        {showInputArea && (
          <>
            {/* SECOND GAMES */}
            <div className={classes.sectionContainer}>
              <div className={classesK.sectionTitle}>
                Opcija 1 - Upiši kvote za 2. igre{' '}
                {disabled.secondGames && (
                  <button
                    className={classes.button}
                    onClick={() => showResults(setToggleSecondResults)}
                    disabled={loading}
                  >
                    {loading ? 'Učitavanje...' : 'Prikaži rezultate'}
                  </button>
                )}
              </div>
              <OddsCalculator
                field={'secondGames'}
                data={data.values}
                setData={setData}
                labelPrefix={['IGRA 1', 'IGRA 2', 'KVOTA 1', 'KVOTA 2']}
                step={['', '', '0.1', '0.1']}
                min={['', '', '0.1', '0.1']}
                type={['text', 'text', 'number', 'number']}
                rows={2}
                setError={setError}
              />
              {toggleSecondResults && (
                <>
                  <ResultsSection
                    title='Opcija 1 - Obračun za 2. igre'
                    results={data.results.secondGames.profit}
                    names={['Marža kladionice ( ukupna na 2. igre )']}
                  />
                  <ResultsSection
                    subtitle='Procentualne šanse kladionice'
                    results={data.results.secondGames.chances.flatMap(
                      (chance, i) =>
                        i < data.results.secondGames.names.length
                          ? [data.results.secondGames.names[i], chance]
                          : []
                    )}
                    names={Array.from(
                      { length: data.results.secondGames.names.length },
                      (_, i) => [`IGRA ${i + 1}`, '% šanse kladionice']
                    ).flat()}
                    rows={2}
                  />
                  <ResultsSection
                    subtitle='Realno nivelisane kvote'
                    results={data.results.secondGames.realOdds.flatMap(
                      (realOdd, i) =>
                        i < data.results.secondGames.names.length
                          ? [data.results.secondGames.names[i], realOdd]
                          : []
                    )}
                    names={Array.from(
                      { length: data.results.secondGames.names.length },
                      (_, i) => [`IGRA ${i + 1}`, 'Realna kvota']
                    ).flat()}
                    rows={2}
                  />
                  <ResultsSection
                    subtitle='Realno nivelisani procenti'
                    results={data.results.secondGames.realOddsPercentage.flatMap(
                      (percentage, i) =>
                        i < data.results.secondGames.names.length
                          ? [
                              data.results.secondGames.names[i],
                              `${percentage}%`,
                            ]
                          : []
                    )}
                    names={Array.from(
                      { length: data.results.secondGames.names.length },
                      (_, i) => [`IGRA ${i + 1}`, 'Realan % procenat']
                    ).flat()}
                    rows={2}
                  />
                </>
              )}
            </div>

            {/* THIRD GAMES */}
            <div className={classes.sectionContainer}>
              <div className={classesK.sectionTitle}>
                Opcija 1 - Upiši kvote za 3. igre{' '}
                {disabled.thirdGames && (
                  <button
                    className={classes.button}
                    onClick={() => showResults(setToggleThirdResults)}
                    disabled={loading}
                  >
                    {loading ? 'Učitavanje...' : 'Prikaži rezultate'}
                  </button>
                )}
              </div>
              <OddsCalculator
                field={'thirdGames'}
                data={data.values}
                setData={setData}
                labelPrefix={[
                  'IGRA 1',
                  'IGRA 2',
                  'IGRA 3',
                  'KVOTA 1',
                  'KVOTA 2',
                  'KVOTA 3',
                ]}
                step={['', '', '', '0.1', '0.1', '0.1']}
                min={['', '', '', '0.1', '0.1', '0.1']}
                type={['text', 'text', 'text', 'number', 'number', 'number']}
                rows={3}
                setError={setError}
              />
              {toggleThirdResults && (
                <>
                  <ResultsSection
                    title='Opcija 1 - Obračun za 3. igre'
                    results={data.results.thirdGames.profit}
                    names={['Marža kladionice ( ukupna na 3. igre )']}
                  />
                  <ResultsSection
                    subtitle='Procentualne šanse kladionice'
                    results={data.results.thirdGames.chances.flatMap(
                      (chance, i) =>
                        i < data.results.thirdGames.names.length
                          ? [data.results.thirdGames.names[i], chance]
                          : []
                    )}
                    names={Array.from(
                      { length: data.results.thirdGames.names.length },
                      (_, i) => [`IGRA ${i + 1}`, '% šanse kladionice']
                    ).flat()}
                    rows={3}
                  />
                  <ResultsSection
                    subtitle='Realno nivelisane kvote'
                    results={data.results.thirdGames.realOdds.flatMap(
                      (realOdd, i) =>
                        i < data.results.thirdGames.names.length
                          ? [data.results.thirdGames.names[i], realOdd]
                          : []
                    )}
                    names={Array.from(
                      { length: data.results.thirdGames.names.length },
                      (_, i) => [`IGRA ${i + 1}`, 'Realna kvota']
                    ).flat()}
                    rows={3}
                  />
                  <ResultsSection
                    subtitle='Procenat kvote (%)'
                    results={data.results.thirdGames.realOddsPercentage.flatMap(
                      (percentage, i) =>
                        i < data.results.thirdGames.names.length
                          ? [data.results.thirdGames.names[i], `${percentage}%`]
                          : []
                    )}
                    names={Array.from(
                      { length: data.results.thirdGames.names.length },
                      (_, i) => [`IGRA ${i + 1}`, 'Realan % procenat']
                    ).flat()}
                    rows={3}
                  />
                </>
              )}
            </div>

            {/* FOURTH GAMES */}
            <div className={classes.sectionContainer}>
              <div className={classesK.sectionTitle}>
                Opcija 1 - Upiši kvote za 4. igre{' '}
                {disabled.fourthGames && (
                  <button
                    className={classes.button}
                    onClick={() => showResults(setToggleFourthResults)}
                    disabled={loading}
                  >
                    {loading ? 'Učitavanje...' : 'Prikaži rezultate'}
                  </button>
                )}
              </div>
              <OddsCalculator
                field={'fourthGames'}
                data={data.values}
                setData={setData}
                labelPrefix={[
                  'IGRA 1',
                  'IGRA 2',
                  'IGRA 3',
                  'IGRA 4',
                  'KVOTA 1',
                  'KVOTA 2',
                  'KVOTA 3',
                  'KVOTA 4',
                ]}
                step={['', '', '', '', '0.1', '0.1', '0.1', '0.1']}
                min={['', '', '', '', '0.1', '0.1', '0.1', '0.1']}
                type={[
                  'text',
                  'text',
                  'text',
                  'text',
                  'number',
                  'number',
                  'number',
                  'number',
                ]}
                rows={4}
                setError={setError}
              />
              {toggleFourthResults && (
                <>
                  <ResultsSection
                    title='Opcija 1 - Obračun za 4. igre'
                    results={data.results.fourthGames.profit}
                    names={['Marža kladionice ( ukupna na 4. igre )']}
                  />
                  <ResultsSection
                    subtitle='Procentualne šanse kladionice'
                    results={data.results.fourthGames.chances.flatMap(
                      (chance, i) =>
                        i < data.results.fourthGames.names.length
                          ? [data.results.fourthGames.names[i], chance]
                          : []
                    )}
                    names={Array.from(
                      { length: data.results.fourthGames.names.length },
                      (_, i) => [`IGRA ${i + 1}`, '% šanse kladionice']
                    ).flat()}
                    rows={4}
                  />
                  <ResultsSection
                    subtitle='Realno nivelisane kvote'
                    results={data.results.fourthGames.realOdds.flatMap(
                      (realOdd, i) =>
                        i < data.results.fourthGames.names.length
                          ? [data.results.fourthGames.names[i], realOdd]
                          : []
                    )}
                    names={Array.from(
                      { length: data.results.fourthGames.names.length },
                      (_, i) => [`IGRA ${i + 1}`, 'Realna kvota']
                    ).flat()}
                    rows={4}
                  />
                  <ResultsSection
                    subtitle='Procenat kvote (%)'
                    results={data.results.fourthGames.realOddsPercentage.flatMap(
                      (percentage, i) =>
                        i < data.results.fourthGames.names.length
                          ? [
                              data.results.fourthGames.names[i],
                              `${percentage}%`,
                            ]
                          : []
                    )}
                    names={Array.from(
                      { length: data.results.fourthGames.names.length },
                      (_, i) => [`IGRA ${i + 1}`, 'Realan % procenat']
                    ).flat()}
                    rows={4}
                  />
                </>
              )}
            </div>

            {/* FIFTH GAMES */}
            <div className={classes.sectionContainer}>
              <div className={classesK.sectionTitle}>
                Opcija 1 - Upiši kvote za 5. igre{' '}
                {disabled.fifthGames && (
                  <button
                    className={classes.button}
                    onClick={() => showResults(setToggleFifthResults)}
                    disabled={loading}
                  >
                    {loading ? 'Učitavanje...' : 'Prikaži rezultate'}
                  </button>
                )}
              </div>
              <OddsCalculator
                field={'fifthGames'}
                data={data.values}
                setData={setData}
                labelPrefix={[
                  'IGRA 1',
                  'IGRA 2',
                  'IGRA 3',
                  'IGRA 4',
                  'IGRA 5',
                  'KVOTA 1',
                  'KVOTA 2',
                  'KVOTA 3',
                  'KVOTA 4',
                  'KVOTA 5',
                ]}
                step={['', '', '', '', '', '0.1', '0.1', '0.1', '0.1', '0.1']}
                min={['', '', '', '', '', '0.1', '0.1', '0.1', '0.1', '0.1']}
                type={[
                  'text',
                  'text',
                  'text',
                  'text',
                  'text',
                  'number',
                  'number',
                  'number',
                  'number',
                  'number',
                ]}
                rows={5}
                setError={setError}
              />
              {toggleFifthResults && (
                <>
                  <ResultsSection
                    title='Opcija 1 - Obračun za 5. igre'
                    results={data.results.fifthGames.profit}
                    names={['Marža kladionice ( ukupna na 5. igre )']}
                  />
                  <ResultsSection
                    subtitle='Procentualne šanse kladionice'
                    results={data.results.fifthGames.chances.flatMap(
                      (chance, i) =>
                        i < data.results.fifthGames.names.length
                          ? [data.results.fifthGames.names[i], chance]
                          : []
                    )}
                    names={Array.from(
                      { length: data.results.fifthGames.names.length },
                      (_, i) => [`IGRA ${i + 1}`, '% šanse kladionice']
                    ).flat()}
                    rows={5}
                  />
                  <ResultsSection
                    subtitle='Realno nivelisane kvote'
                    results={data.results.fifthGames.realOdds.flatMap(
                      (realOdd, i) =>
                        i < data.results.fifthGames.names.length
                          ? [data.results.fifthGames.names[i], realOdd]
                          : []
                    )}
                    names={Array.from(
                      { length: data.results.fifthGames.names.length },
                      (_, i) => [`IGRA ${i + 1}`, 'Realna kvota']
                    ).flat()}
                    rows={5}
                  />
                  <ResultsSection
                    subtitle='Procenat kvote (%)'
                    results={data.results.fifthGames.realOddsPercentage.flatMap(
                      (percentage, i) =>
                        i < data.results.fifthGames.names.length
                          ? [data.results.fifthGames.names[i], `${percentage}%`]
                          : []
                    )}
                    names={Array.from(
                      { length: data.results.fifthGames.names.length },
                      (_, i) => [`IGRA ${i + 1}`, 'Realan % procenat']
                    ).flat()}
                    rows={5}
                  />
                </>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  )
}

export default NivelacijaKvota
